import React, { useState } from "react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import { Tabs } from "@amzn/awsui-components-react";
import { useSearchParams } from "react-router-dom";
import DarkModeContext from "../../contexes/DarkModeContext";
import { ChatUatContextReference } from "../../lusca-search-api/generated-src";
import PageHeader from "../PageHeader";
import ChatUatPage from "./ChatUatPage";
import UatScopeValidationPage from "./UatScopeValidationPage";

export const ChatUatPortal: React.FC = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const activeView =
    searchParams.get("view") === "validate" ? "validate" : "chat";
  const selectView = (view: string) => {
    const next = new URLSearchParams(searchParams);
    next.set("view", view);
    if (view === "chat") {
      ["runId", "taskGid", "orderId"].forEach((key) => next.delete(key));
    }
    setSearchParams(next, { replace: true });
  };

  const investigate = (reference: ChatUatContextReference) => {
    const next = new URLSearchParams(searchParams);
    next.set("view", "chat");
    next.set("runId", reference.runId);
    next.set("taskGid", reference.taskGid);
    if (reference.orderId) {
      next.set("orderId", reference.orderId);
    } else {
      next.delete("orderId");
    }
    setSearchParams(next);
  };

  return (
    <DarkModeContext.Provider value={darkMode}>
      <PageHeader setDarkMode={setDarkMode} />
      <AppLayout
        contentType="default"
        headerSelector="#h"
        maxContentWidth={1700}
        navigationHide
        toolsHide
        content={
          <Tabs
            activeTabId={activeView}
            onChange={({ detail }) => selectView(detail.activeTabId)}
            tabs={[
              {
                id: "chat",
                label: "Chat",
                content: <ChatUatPage />,
              },
              {
                id: "validate",
                label: "UAT workflow",
                content: <UatScopeValidationPage onInvestigate={investigate} />,
              },
            ]}
          />
        }
      />
    </DarkModeContext.Provider>
  );
};
